module.exports = __webpack_public_path__ + "img/question-cross-close.e3ea37b0.svg";